import React from 'react'
import HotelFacilitiesTable from './hotelFacilitiesTable.jsx'
import { object, string, array } from 'prop-types'

class HotelInformation extends React.Component {
  render () {
    const { productData: product = {}, id, functionParams } = this.props
    const productName = functionParams[1] || product._base_name || product.name

    return (
      <div id={id}>
        { product.hotel_arrival && (
          <div>
            <h2>Arrival at the { productName }</h2>
            <p dangerouslySetInnerHTML={{ __html: product.hotel_arrival }} />
          </div>
        )}
        { product.hotel_depart && (
          <div>
            <h2>Checking Out</h2>
            <p dangerouslySetInnerHTML={{ __html: product.hotel_depart }} />
          </div>
        )}
        { product.tripapptransferstory && (
          <div>
            <h2>Getting to and from { product._airport_info.name } airport</h2>
            <p dangerouslySetInnerHTML={{ __html: product.tripapptransferstory }} />
          </div>
        )}

        <HotelFacilitiesTable productData={product} productName={productName} />

        { product.prices && product.prices.startDate && (
          <p><small>* Prices quoted are stays on the { product.prices.startDate }, valid as of { product.prices.dateUsed }</small></p>
        )}

      </div>
    )
  }
}

HotelInformation.propTypes = {
  productData: object,
  functionParams: array,
  id: string
}

HotelInformation.defaultProps = {
  productData: { }
}

export default HotelInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/hotelInformation.jsx